import { Style } from 'inlines'
import { Toggle, ToggleOption } from './Toggle'
import { useTranslations } from '@i18n/useLanguage'

export type YesNoOtherToggleProps<T> = {
  otherLabel?: string
  optionValues: {
    yes: T
    no: T
    other: T
  }
  selected: T
  setSelected: (option: T) => void
}

export const YesNoOtherToggle = <T extends string>({
  otherLabel,
  optionValues,
  selected,
  setSelected,
}: YesNoOtherToggleProps<T>) => {
  const translations = useTranslations().app.common
  const style: Style = {
    width: '4.125rem',
  }
  const options: ToggleOption<T>[] = [
    {
      label: translations.yes,
      value: optionValues.yes,
      style: style,
    },
    {
      label: translations.no,
      value: optionValues.no,
      style: style,
    },
    {
      label: otherLabel ?? translations.other,
      value: optionValues.other,
      style: { paddingInline: '1rem' },
    },
  ]
  return (
    <Toggle
      options={options}
      selectedOption={selected}
      setSelectedOption={setSelected}
    />
  )
}
